import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import 'remixicon/fonts/remixicon.css';
import {jwtDecode} from "jwt-decode";
import CategoryList from "./Pages/CategoryList";

const MenuList = lazy(() => import("./Pages/MenuList"));
const DishDetails = lazy(() => import("./Pages/DishDetails"));
const Login = lazy(() => import("./Pages/Login"));
const Admin = lazy(() => import("./Pages/Admin"));
const ProductList = lazy(() => import("./Pages/ProductList"));
const ProductSort = lazy(() => import("./Pages/ProductsSort"));



// Wrapper for protecting routes
const AuthProtectedRoute = ({ element }) => {
  const token = localStorage.getItem("token");

  const isTokenValid = () => {
    if (!token) return false;

    try {
      const decoded = jwtDecode(token);
      
      
      const currentTime = Date.now() / 1000; // in seconds

      return decoded.exp && decoded.exp > currentTime;
    } catch (err) {
      return false;
    }
  };

  return isTokenValid() ? element : <Navigate to="/login" replace />;
};

function App() {
  return (
    <Router>
      <Suspense >
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<MenuList />} />
          <Route path="/item/:id" element={<DishDetails />}  />

          {/* Protected Routes */}
          <Route path="/category-list" element={<AuthProtectedRoute element={<CategoryList />} />} />
          <Route path="/products-sort" element={<AuthProtectedRoute element={<ProductSort />} />} />
          <Route path="/admin" element={<AuthProtectedRoute element={<Admin />} />} />
          <Route path="/admin/foods" element={<AuthProtectedRoute element={<ProductList />} />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;